<template>
	<div>
		<az-back-button
			id="azBackButton"
			text="voltar para listagem"
			:route="{ name: nomeRota, params: parametrosRotaVoltar }"
		></az-back-button>
		<az-container>
			<div class="cabecalho-customizado">
				<div class="d-flex flow-row justify-start align-content-stretch">
					<div class="infoCabecalho">
						<span class="label">N° Adesão</span>
						<span class="item-text">{{ (adesao || {}).numero || '--' }}</span>
					</div>
					<div class="infoCabecalho">
						<span class="label">Órgão Aderente</span>
						<span v-if="isAdesaoExterna">
							<texto-tooltip
								class="item-text"
								:texto="(adesao.solicitacaoAdesao || {}).nomeOrgao || '---'"
								:tamanho-maximo="40"
							></texto-tooltip>
						</span>
						<span v-else class="item-text">{{ ((adesao || {}).unidadeOrganizacional || {}).sigla }}</span>
					</div>

					<div class="infoCabecalho">
						<span class="label">Criação</span>
						<span class="item-text">{{
							(getCurrentTaskBpmn(getProcessKeyAtual(), businessKey) || {}).startDate | formatDataFilter
						}}</span>
					</div>

					<div v-if="!isAdesaoExterna" class="infoCabecalho">
						<span class="label">Usuário</span>
						<span class="item-text">{{ (adesao.usuarioAdesao || {}).nome || '---' }}</span>
					</div>

					<div v-if="adesao.utilizaFluxo" class="infoCabecalho">
						<span class="label">Atividade</span>
						<span class="item-text d-flex flex-row align-center" :key="temPermissao && !isAtaProrrogada">
							{{ adesao.atividadeNome }}
							<v-btn
								v-if="estaRecusada && isAdesaoExterna"
								icon
								x-small
								class="ms-2"
								@click="abrirModalJustificativa"
							>
								<v-icon>mdi-message</v-icon>
							</v-btn>
						</span>
					</div>

					<div v-if="isAdesaoExterna && !adesao.utilizaFluxo" class="infoCabecalho">
						<span class="label">Situação</span>
						<span class="item-text d-flex flex-row align-center">
							{{ filtrarSituacaoAdesao(adesao.situacao) }}
							<v-btn v-if="estaRecusada" icon x-small class="ms-2" @click="abrirModalJustificativa"
								><v-icon>mdi-message</v-icon></v-btn
							></span
						>
					</div>

					<div v-if="isAdesaoExterna" class="infoCabecalho">
						<modal-ver-mais :solicitacao-adesao="adesao.solicitacaoAdesao"></modal-ver-mais>
					</div>
				</div>

				<div class="botoes-acoes">
					<botao-primario
						v-if="existeRevisaoParaAdesao && !isAtaCancelada"
						outlined
						:nome-botao="revisao.tipo"
						cor-de-fundo="white"
						@click="criarRevisaoAdesao"
					></botao-primario>
					<botao-processo-digital
						v-if="podeExibirBotaoProcessoDigital && !existeRevisaoParaAdesao"
						class="align-center justify-center mx-2"
						:is-edocs="isIntegracaoEdocsAtivo"
						:is-ata-cancelada="isAtaCancelada"
						@acessar="visualizarProcessoDigital"
						@enviar-edocs="enviarEdocs"
						v-az-auth="permissoes.ataAdesaoProcessoDigitalVisualizar"
					></botao-processo-digital>
					<botao-primario
						data-test="button.enviar"
						outlined
						nome-botao="EXPORTAR ADESÃO"
						v-az-auth="permissoes.ataAdesaoEnviarIntegracao"
						has-authority
						@click="enviarAdesaoIntegracao"
						class="align-center justify-center mx-2"
						v-if="
							!gerarAtaAdesao &&
							temPermissao &&
							!isAtaProrrogada &&
							isPermissaoAutorizada(permissoes.ataAdesaoEnviarIntegracao) &&
							isConcluida &&
							!estaRecusada &&
							verificarPermissao(permissoes.ataAdesaoEnviarIntegracao) &&
							!isAtaCancelada
						"
					></botao-primario>
					<botao-primario
						data-test="button.concluir"
						outlined
						nome-botao="Concluir"
						v-az-auth="permissoes.ataAdesaoConcluir"
						has-authority
						@click="abrirModalConcluir"
						class="align-center justify-center mx-2"
						v-if="
							temPermissao &&
							!isAtaProrrogada &&
							isPermissaoAutorizada(permissoes.ataAdesaoConcluir) &&
							!isConcluida &&
							!estaRecusada &&
							!isAtaCancelada
						"
					></botao-primario>
					<botao-primario
						v-if="
							temPermissao &&
							!isAtaProrrogada &&
							isPermissaoAutorizada(permissoes.ataAdesaoRecusar) &&
							!isConcluida &&
							!estaRecusada &&
							isAdesaoExterna &&
							!isAtaCancelada
						"
						outlined
						nome-botao="Recusar"
						@click="abrirModalJustificativaRecusar"
					>
					</botao-primario>
					<botao-primario
						v-if="
							isPodeReenviarDetalhamento &&
							isPermissaoAutorizada(permissoes.adesaoIntegracaoDetalhamentoEnviar) &&
							!isAtaCancelada
						"
						v-az-auth="permissoes.adesaoIntegracaoDetalhamentoEnviar"
						outlined
						has-authority
						nome-botao="Reenviar Detalhamento"
						icone="mdi-send"
						class="align-center justify-center mx-2"
						@click="reenviarDetalhamento"
					></botao-primario>
					<az-bpm-action
						v-if="!isAtaProrrogada && adesao.utilizaFluxo && !isAtaCancelada"
						:after-action="actionAfterBpm"
						:before-action="tratarParametros"
						:business-key="businessKey"
						:button-attrs="{
							claim: {
								class: getClassButton('claim', `text-none order-0 text-uppercase ${botaoClasse}`),
								outlined: true,
							},
							unclaim: {
								class: getClassButton(
									'unclaim',
									`text-none order-1 ms-3 text-uppercase v-btn--width-auto ${botaoClasse}`,
								),
								text: true,
							},
							complete: {
								class: getClassButton('complete', `text-none order-0 text-uppercase ${botaoClasse}`),
								outlined: true,
							},
							uncomplete: {
								class: getClassButton(
									'uncomplete',
									`text-none order-1 ms-3 text-uppercase ${botaoClasse}`,
								),
								text: true,
							},
						}"
						:process-key="getProcessKeyAtual()"
						class="bpm-action-adesao mx-2"
					>
						<template #claim="{ button }">
							<span v-if="false">{{ button.label }}</span>
						</template>
						<template #unclaim="{ button }">
							<icone-tooltip
								tamanho="auto"
								icone="mdi-undo-variant"
								:texto="button.label"
								cor="white"
							></icone-tooltip>
						</template>
						<template #uncomplete="{ button }">
							<icone-tooltip
								tamanho="auto"
								icone="mdi-undo-variant"
								:texto="button.label"
								cor="white"
							></icone-tooltip>
						</template>
					</az-bpm-action>
					<menu-acoes
						v-if="podeExibirBotaoAcoesCabecalho"
						cor-icone="--v-error-base"
						icone-secondary="mdi-dots-vertical"
						:outlined="false"
						block
						cor-de-fundo="grey"
						:acoes-menu="acoesMenuCabecalho"
						tamanho-icone-menu="18px"
						@acessar-processo-digital="visualizarProcessoDigital"
					></menu-acoes>
				</div>
			</div>
			<az-container>
				<painel-com-tabs :getter="getterAbas" ref="painelTabsAdesaoRef"></painel-com-tabs>
			</az-container>
		</az-container>
		<modal-exibir-justificativa
			:justificativa="adesao.justificativaCancelamento"
			titulo="Reprovação da Adesão Pública"
			@fechar="fecharModalJustificativa"
			:exibir="exibirModalExibeJustificativa"
		></modal-exibir-justificativa>
		<modal-concluir-adesao
			:exibir="exibirModalConcluir"
			:possui-itens-pendentes="possuiItensPendentes"
			@fechar-modal="fecharModalConcluir"
			@concluir="concluirAdesao"
		></modal-concluir-adesao>
		<modal
			:exibir="exibirModalRecusar"
			titulo="Reprovação da adesão"
			max-width="600"
			:custom-actions="false"
			:acao-cancelar="fecharModalRecusar"
			@close="fecharModalRecusar"
			:acao-confirmar="recusarAdesao"
			nome-botao-confirmar="Enviar"
			:is-confirmar-desabilitado="!formRecusarIsValid"
			is-confirmar-visivel
		>
			<template #body>
				<div class="mx-2 my-5">
					<v-form lazy-validation ref="formRecusar" v-model="formRecusarIsValid">
						<label-personalizado
							nome-campo="Motivo Reprovação"
							obrigatorio-por-padrao
							class="mt-2"
						></label-personalizado>
						<v-textarea
							counter="300"
							rows="5"
							:rules="justificativaRule"
							v-model="justificativa"
						></v-textarea>
					</v-form>
				</div>
			</template>
		</modal>
		<modal-edocs
			v-if="podeExibirModalEdocs"
			:id-processo-digital="adesao.idProcessoDigitalExterno"
			:exibir="exibirModalEdocs"
			@fechar-modal-edocs="fecharModalEdocs"
		></modal-edocs>
	</div>
</template>
<script>
import PainelComTabs from '@/views/components/PainelComTabs.vue'
import {
	actionTypes,
	getterTypes,
	mutationTypes,
	opcaoSimNao,
	permissoes,
	routesNames,
	situacoes,
} from '@/core/constants'
import deslogarOrgao from '@/views/mixins/deslogarOrgao'
import logarOrgao from '@/views/mixins/logarOrgao'
import { mapState } from 'vuex'
import IconeTooltip from '@/views/components/IconeTooltip.vue'
import ModalExibirJustificativa from '@/views/pages/adesao/aderente/modal-exibir-justificativa/ModalExibirJustificativa.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import ModalConcluirAdesao from '@/views/pages/adesao/aderente/modal-concluir-adesao/ModalConcluirAdesao.vue'
import ModalVerMais from '@/views/pages/adesao/aderente/modal-ver-mais/ModalVerMais.vue'
import Modal from '@/views/components/Modal.vue'
import situacaoFilter from '../../../filters/situacao-filter'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import BotaoProcessoDigital from '@/views/components/BotaoProcessoDigital.vue'
import ModalEdocs from '@/views/components/ModalEdocs.vue'
import adesaoAta from '@/views/mixins/adesaoAta'
import validacaoAta from '@/views/mixins/validacaoAta'
import TipoOcorrencia from '@/core/constants/tipo-ocorrencia'
import MenuAcoes from '@/views/components/MenuAcoes.vue'

export default {
	name: 'adesao-aderente-view',
	components: {
		MenuAcoes,
		ModalEdocs,
		BotaoProcessoDigital,
		Modal,
		ModalVerMais,
		ModalConcluirAdesao,
		BotaoPrimario,
		ModalExibirJustificativa,
		IconeTooltip,
		PainelComTabs,
	},
	mixins: [deslogarOrgao, logarOrgao, validacaoFormulario, adesaoAta, validacaoAta],
	provide() {
		return {
			idAdesao: this.$route.params.id,
		}
	},
	data() {
		return {
			idAdesao: this.$route.params.id,
			componentes: null,
			numeroProcessoObrigatorio: true,
			botaoClasse: 'acessar-adesao-view__btn-bpm',
			exibirModalExibeJustificativa: false,
			exibirModalConcluir: false,
			possuiItensPendentes: false,
			parametrosRotaVoltar: { id: this.$store.state.ata.informacoesAta.id },
			exibirModalRecusar: false,
			formRecusarIsValid: false,
			justificativa: null,
			justificativaRule: [
				(value) => this.regraObrigatoriedade(value, 'O motivo da reprovação é obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						300,
						'O campo motivo da reprovação deve ser igual ou menor do que 300 caracteres.',
					),
			],
			exibirModalEdocs: false,
			acoesMenuCabecalho: [
				{
					titulo: 'Processo Digital',
					evento: 'acessar-processo-digital',
					icone: {
						nome: 'mdi-open-in-new',
					},
					authorization: permissoes.ataAdesaoProcessoDigitalVisualizar,
					isVisible: this.podeExibirBotaoProcessoDigitalNoMenuAcoes,
				},
			],
		}
	},
	computed: {
		getterAbas() {
			return getterTypes.ADESAO.GET_ABAS_ADESAO
		},
		...mapState({
			adesao: (state) => state.adesao.informacoesAdesao || {},
			isIntegracaoTceAtivo: (state) => state.parametrosSistema.isIntegracaoTceAtivo || false,
			isIntegracaoEdocsAtivo: (state) => state.parametrosSistema.isIntegracaoEdocsAtivo || false,
			gerarAtaAdesao: (state) => state.parametrosSistema.isGerarAtaAdesao || false,
			revisao: (state) => state.adesao.revisao,
		}),
		temPermissao() {
			if (this.process) return this.process.hasAuthority()
			if (this.isAdesaoExterna && !this.adesao.utilizaFluxo) return this.adesao.usuarioEhGestor
			return false
		},
		isAtaProrrogada() {
			return this.ehHistoricoProrrogacao(this.adesao?.ataRegistroPreco.situacao)
		},
		nomeRota() {
			return routesNames.ATA.ATA_ACESSAR_MINHAS_ADESOES_VIEW
		},
		podeExibirBotaoProcessoDigital() {
			return this.adesao.isProcessoVirtualizacaoDiferenteDaAta && this.adesao.isExibirAcoesProcessoDigital
		},
		podeExibirModalEdocs() {
			return this.isIntegracaoEdocsAtivo && this.exibirModalEdocs
		},
		isPodeReenviarDetalhamento() {
			return this.isIntegracaoTceAtivo && !this.adesao.isEnviadoDetalhamento && this.isAdesaoAceita
		},
		podeExibirBotaoAcoesCabecalho() {
			return this.podeExibirBotaoProcessoDigitalNoMenuAcoes()
		},
		existeRevisaoParaAdesao() {
			return this.revisao !== null && !!this.revisao.id
		},
		isAtaCancelada() {
			return this.estaCancelada(this.adesao.ataRegistroPreco?.situacao)
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ADESAO.RESET_PAGINACAO_LISTAGEM)
	},
	async mounted() {
		await this.carregarInfoAdesao()
		this.carregarInformacoesOcorrencia()
		await this.atualizaInstanciaDoProcesso()
	},
	methods: {
		async actionAfterBpm(obj) {
			await Promise.all([await this.carregarInfoAdesao(), await this.atualizaInstanciaDoProcesso(obj)])

			this.$store.commit(mutationTypes.ADESAO.SET_ATUALIZA_LISTAGEM)
			this.desativarCarregamentoManual()
			await this.exibirNotificacoes(obj)
		},
		async exibirNotificacoes(resultadoAcao) {
			if (resultadoAcao.error) {
				this.mostrarNotificacaoErroFluxo(resultadoAcao.error)
			} else {
				this.mostrarNotificacaoSucessoDefault()
			}
		},

		mostrarNotificacaoErroFluxo(erro) {
			this.mostrarNotificacaoErro(erro.response?.data?.message || 'Erro desconhecido')
		},
		buscarBotao(tipo) {
			if (this.componentes) {
				const { button } = this.componentes
				return button[tipo]
			}
			return null
		},
		getClassButton(tipo, classePadrao) {
			let btnClaim = this.buscarBotao(tipo)
			if (btnClaim && !btnClaim.disabled) return classePadrao
			return 'd-none'
		},
		async carregarInfoAdesao() {
			await Promise.all([this.carregarAdesao(this.adesao.id), this.buscarRevisaoDisponivel()])

			this.numeroProcessoObrigatorio = this.adesao.isNumeroProcessoObrigatorio
			this.parametrosRotaVoltar = { id: this.adesao.ataRegistroPreco.id }
		},
		carregarInformacoesOcorrencia() {
			this.$store.commit(mutationTypes.OCORRENCIA.SET_INFORMACOES_OCORRENCIA, {
				idEntidade: this.adesao.id,
				tipoEntidade: TipoOcorrencia.ADESAO.value,
			})
		},
		abrirModalJustificativa() {
			this.exibirModalExibeJustificativa = true
		},
		fecharModalJustificativa() {
			this.exibirModalExibeJustificativa = false
		},
		async tratarParametros(buttonType, bpmParameters) {
			this.ativarCarregamentoManual()
			if (buttonType === 'complete' && !!bpmParameters.humanDecision) {
				let task = this.processInstance.currentTask.nextTasks.filter(
					(task) => task.taskId === bpmParameters.humanDecision,
				)[0]

				if (task.type === 'userTask') {
					let extensions = await this.$store.dispatch(actionTypes.ADESAO.BPM.BUSCAR_EXTENSIONS_TASKS, {
						taskDefinitionKey: bpmParameters.humanDecision,
						isAdesaoExterna: this.isAdesaoExterna,
					})

					let isPermissaoGestor = extensions.permissaoGestor

					if (isPermissaoGestor === opcaoSimNao.SIM.value || this.isAdesaoExterna) {
						bpmParameters.uoDestinationId = this.adesao.ataRegistroPreco.orgaoGerenciador.id
						bpmParameters.uoOriginId = this.processInstance.currentTask.currentUo.id
					} else {
						bpmParameters.uoDestinationId = this.adesao.unidadeOrganizacional.id
						bpmParameters.uoOriginId = this.processInstance.currentTask.currentUo.id
					}
				}
			}

			return true
		},

		async fecharModalConcluir() {
			this.exibirModalConcluir = false
			await this.carregarInfoAdesao()
		},

		async abrirModalConcluir() {
			this.possuiItensPendentes = await this.adesaoPossuiItensPendentes()
			this.exibirModalConcluir = true
		},

		async enviarAdesaoIntegracao() {
			await this.$store.dispatch(actionTypes.ADESAO.INTEGRACAO.ENVIAR, this.adesao.id)
			this.mostrarNotificacaoSucesso('Adesão enviada para integração com sucesso!')
		},

		async adesaoPossuiItensPendentes() {
			const data = await this.$store.dispatch(actionTypes.ADESAO.POSSUI_ITENS_PENDENTES, {
				idAdesao: this.adesao.id,
			})

			return data.possuiItensPendentes
		},
		async concluirAdesao() {
			await this.$store.dispatch(actionTypes.ADESAO.CONCLUIR, { idAdesao: this.adesao.id })

			this.mostrarNotificacaoSucesso(this.mensagemDeSucesso())
			await this.carregarInfoAdesao()
			await this.fecharModalConcluir()
			this.$store.commit(mutationTypes.ADESAO.SET_ATUALIZA_LISTAGEM)
		},
		mensagemDeSucesso() {
			if (this.isAdesaoExterna) return 'Adesão foi concluída com sucesso.'

			return this.gerarAtaAdesao
				? 'Adesão foi concluída e a ata de adesão e os itens serão criados.'
				: 'A adesão foi concluída e os documentos de ordem de utilização estão sendo gerados.'
		},
		abrirModalJustificativaRecusar() {
			this.exibirModalRecusar = true
		},
		fecharModalRecusar() {
			this.exibirModalRecusar = false
		},
		async recusarAdesao() {
			if (this.$refs.formRecusar.validate()) {
				await this.$store.dispatch(actionTypes.ADESAO.RECUSAR, {
					idAdesao: this.adesao.id,
					justificativaCancelamento: this.justificativa,
				})

				this.mostrarNotificacaoSucesso('Adesão recusada com sucesso!')
				await this.carregarInfoAdesao()
				this.fecharModalRecusar()
			}
		},
		filtrarSituacaoAdesao(situacao) {
			return situacaoFilter(situacao, situacoes.ADESAO)
		},
		async visualizarProcessoDigital() {
			const { url } = await this.$store.dispatch(actionTypes.ADESAO.VISUALIZAR_PROCESSO_DIGITAL, this.adesao.id)

			if (!url && this.isIntegracaoEdocsAtivo) {
				this.mostrarNotificacaoWarning(
					'Não é possível acessar o processo no e-Docs pois ainda não foi enviado nenhum documento.',
				)
				return
			}

			window.open(url, '_blank')
		},
		enviarEdocs() {
			this.exibirModalEdocs = true
		},
		fecharModalEdocs() {
			const abaAtual = this.$refs.painelTabsAdesaoRef?.$refs.childRef

			if (abaAtual) abaAtual.$refs.docsAdesaoRef?.carregarDocumentos()
			this.exibirModalEdocs = false
		},
		async reenviarDetalhamento() {
			await this.$store
				.dispatch(actionTypes.ADESAO.REENVIAR_ADESAO_PARA_DETALHAMENTO, this.adesao.id)
				.then(() => {
					this.adesao['isEnviadoDetalhamento'] = true
					this.mostrarNotificacaoSucessoDefault()
				})
		},
		podeExibirBotaoProcessoDigitalNoMenuAcoes() {
			return this.podeExibirBotaoProcessoDigital && this.existeRevisaoParaAdesao
		},
		async buscarRevisaoDisponivel() {
			await this.executarSemLoading(() => {
				this.$store.dispatch(actionTypes.ADESAO.REVISOES.BUSCAR_DISPONIVEL, this.idAdesao)
			})
		},
		async acoesAposRevisao() {
			if (this.revisao.encaminhamentoAutomatico === 'SIM') {
				await this.carregarInfoAdesao()
				await this.atualizaInstanciaDoProcesso()
			} else {
				this.mostrarNotificacaoSucesso('Documento gerado com sucesso')
			}

			await this.$router.push({
				name: routesNames.ADESAO.ADERENTE.ADESAO_ITENS,
				params: {
					id: this.idAdesao,
					tipoAcesso: this.$route.params.tipoAcesso,
				},
			})
		},
		async criarRevisaoAdesao() {
			await this.$store.dispatch(actionTypes.ADESAO.REVISOES.CRIAR, {
				idAdesao: this.idAdesao,
				revisao: {
					idRevisao: this.revisao.id,
				},
			})
			await this.acoesAposRevisao()
		},
	},
}
</script>
<style lang="stylus">
.cabecalho-customizado
	background-color var(--v-primary-base)
	display flex
	flex-direction row
	justify-content space-between
	color #FFF !important
	height 70px
	padding: .8rem 0.5rem !important;

	.infoCabecalho
		display flex
		flex-direction column
		justify-items space-evenly
		justify-content space-evenly
		margin 0 10px

	.label
		font-weight bold !important
		font-size 0.75em !important
		color white !important

	.item-text
		display inline-flex !important
		font-size .8em !important
		color white !important

	.theme--light.v-btn
		color #FFF !important

.botoes-acoes
	display flex
	flex-direction row
	justify-content flex-end
	justify-items end
	align-items center
</style>
